import {
  axios_nomination,
} from '@/plugins/axios';
import configuration from '@/configurations';

class ExternalPushRepository {

  /**
   * @param {Number} organization_id
   * @param {Object} input
   *
   * @returns {Promise}
   */
  async pushContactToCrm(organization_id, input) {
    const result = await axios_nomination
      .post(
        `${configuration.api_host}/v1/external-push/organizations/${organization_id}/push-form-provider`,
        input
      );

    return result.data;
  }

  /**
   * @param {Number} organization_id
   *
   * @returns {Promise}
   */
  async getFormProviderSettings(organization_id) {
    const result = await axios_nomination
      .get(
        `${configuration.api_host}/v1/external-push/organizations/${organization_id}/form-provider-settings`
      );

    return result.data;
  }
}

const external_push_repository = new ExternalPushRepository();

export {
  external_push_repository,
};
